import React, { Fragment, useEffect, useState, Component, useCallback, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Progress, Label, Input, Spinner, Table, Col, Container, Row, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Button, Badge } from "reactstrap";
import { api } from "../../../config";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import logo from "../../../assets/images/logo-sm.png";
import parse from "html-react-parser";
import classnames from "classnames";
import ModalImage from "react-modal-image";
import ReactApexChart from "react-apexcharts";
import { useReactToPrint } from "react-to-print";
import SimpleBar from "simplebar-react";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";

import moment from "moment";
import { getCivilBudget, resetCivilBudgetState } from "../../../store/civilBudget/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { getDashboard, resetDashboardState } from "../../../store/dashboard/action";
import { resetTransferState, getTransfer } from "../../../store/transfer/action";
import { resetPurchaseState, getPurchase } from "../../../store/purchase/action";
import { find, isEmpty } from "lodash";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import ExportDoc from "../../../Components/Common/ExportDoc";
import PrintDocx from "../PrintDocx";
import Siteplan from "../Siteplan";

const MaterialDashboard = () => {
  document.title = "Dashboard";
  const printSiteRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const unitInfoRef = useRef({});
  const [loadingPrintSite, setLoadingPrintSite] = useState(false);
  const dispatch = useDispatch();
  const date = new Date().getHours();

  //
  const [modal, setModal] = useState(false);
  const [modalMaterial, setModalMaterial] = useState(false);
  const [label, setLabel] = useState([]);
  const [dashboard, setDashboard] = useState({});
  const [info, setInfo] = useState([]);
  const [svg, setSVG] = useState("");
  const [svgProject, setSVGProject] = useState("");
  const [civilBudgetList, setCivilBudgetList] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [productList, setProductList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [block, setBlock] = useState([]);
  const [transferList, setTransferList] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [activeBlock, setActiveBlock] = useState("ALL");
  const [expense, setExpense] = useState([]);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const expanseDataRef = useRef([]);
  const [filterBy, setFilterBy] = useState("");

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, dashboards, loading, error, productVarians, productVarianLoading, civilBudgets, civilBudgetLoading, transfers, transferLoading, purchases, purchaseLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    dashboards: state.Dashboard.dashboards,
    loading: state.Dashboard.loading,
    catalogAvailable: state.Catalog.catalogAvailable,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    transfers: state.Transfer.transfers,
    transferLoading: state.Transfer.loading,
    purchases: state.Purchase.purchases,
    purchaseLoading: state.Purchase.loading,
  }));

  const reactToPrintContent = useCallback(() => {
    return printSiteRef.current;
  }, [printSiteRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrintSite(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrintSite(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrintSite]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let arr = [];
      transfers.forEach((element, key) => {
        if (element.statusId === 2 || element.statusId === 3 || element.statusId === 4 || element.statusId === 5) {
          element.transfer_detail.forEach((el, key) => {
            el.blockId = element.blockId;
            arr.push(el);
          });
        }
      });
      setTransferList(arr);
    }
  }, [transfers]);

  useEffect(() => {
    let list = [];
    let data = [];
    let opt = [];
    civilBudgets.forEach((it, idx) => {
      const name = it.cvl_branch ? it.cvl_branch.name + " - " + it.name : it.name;
      const id = it.id;
      let obj = { label: name, value: id, data: it };
      opt.push(obj);
      (it.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order) || []).forEach((item, key) => {
        let cat = item.cvld_account && item.cvld_account.cvl_account_category ? item.cvld_account.cvl_account_category.name : "";
        let findCategory = list.find((x) => x.category === cat);
        if (findCategory) {
          findCategory.data.push(item);
        } else {
          list.push({ type: it.type, category: cat, data: [item] });
        }
      });
    });
    setCivilBudgetList(list);

    let option = { options: opt };
    data.push(option);
  }, [civilBudgets]);

  useEffect(() => {
    let arrBlok = [];
    for (const varian of productList) {
      let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
      let findBlok = arrBlok.find((x) => x.block === block);
      if (!findBlok) {
        arrBlok.push({ block: block, weight: 0, label: block, unit: 1, value: varian?.pvar_product?.product_block?.id });
      } else {
        findBlok.unit += 1;
      }
    }

    let data = [];
    let option = { options: arrBlok.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);
    setBlockList(data);
  }, [dashboards, civilBudgets, productList]);

  useEffect(() => {
    if (branchSelected && companySelected && clientSelected) {
      setPositionMessage(`${userData?.user?.user_department?.name}, ${userData?.user?.user_position?.name}`);
      handleGetDefault(clientSelected.value, companySelected.value, branchSelected.value, branchSelected.svg_siteplan, branchSelected.svg_siteplan_project);
    }
  }, [branchSelected, companySelected, clientSelected]);

  useEffect(() => {
    if (!isEmpty(dashboards)) {
      setDashboard(dashboards);
    } else {
      setDashboard({});
    }
  }, [dashboards]);

  const handleGetProductVariant = (companyId, branchId, type) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: type, status: 2 }));
  };

  const handleGetTransfer = (id, branchId) => {
    dispatch(resetTransferState());
    dispatch(getTransfer({ companyId: id, branchId: branchId, date: "all" }));
  };

  const handleGetPurchase = (id, branchId) => {
    dispatch(resetPurchaseState());
    dispatch(getPurchase({ companyId: id, branchId: branchId, date: "all" }));
  };

  const handleCivilBudget = (id, branchId, type) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: id, branchId: branchId }));
  };

  const handleGetDefault = (clientId, companyId, branchId, svg, svg_siteplan_project) => {
    dispatch(resetDashboardState());
    dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId }));
    handleCivilBudget(companyId, branchId, "PROGRESS BANGUNAN");
    handleGetProductVariant(companyId, branchId, 1);
    handleGetTransfer(companyId, branchId);
    handleGetPurchase(companyId, branchId);
    setSVG(svg);
    setSVGProject(svg_siteplan_project);
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  useEffect(() => {
    setProductList(productVarians);
  }, [productVarians]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let arr = [];
      transfers.forEach((element, key) => {
        if (element.statusId === 2 || element.statusId === 3 || element.statusId === 4 || element.statusId === 5) {
          element.transfer_detail.forEach((el, key) => {
            el.blockId = element.blockId;
            arr.push(el);
          });
        }
      });
      setTransferList(arr);
    }
  }, [transfers]);

  const { blockMaterialMap, materialOptions } = useMemo(() => {
    let blockMap = {};
    let materialOpt = {};
    (transfers || [])
      .filter((f) => f.statusId === 5)
      .forEach((data) => {
        const blockId = data.blockId ?? null;
        const blockName = data.transfer_block ? data.transfer_block.name : "NON BLOK";
        if (!blockMap[blockId]) blockMap[blockId] = { blockId: blockId, name: blockName, material: {}, detail: {} };
        (data.transfer_detail || []).forEach((td) => {
          const pid = td.productId;
          const qty = isNaN(parseFloat(td.quantity)) ? 0 : parseFloat(td.quantity);
          blockMap[blockId].material[pid] = parseFloat(blockMap[blockId].material[pid] || 0) + qty;
          if (!blockMap[blockId].detail[pid]) blockMap[blockId].detail[pid] = [];
          const job = td?.transfer_cvl_budget_job?.cvld_account?.name ?? "";
          const account = td?.transfer_cvl_account?.name ?? "";
          const type = td?.transfer_cvl_budget?.type ?? "";
          const detail = blockMap[blockId].detail[pid];
          const findDetail = detail.find((d) => d.job === job && d.account === account && d.type === type);
          if (findDetail) {
            findDetail.quantity = parseFloat(findDetail.quantity || 0) + qty;
          } else {
            detail.push({ job: job, account: account, type: type, quantity: qty });
          }
          if (!materialOpt[pid]) {
            materialOpt[pid] = { productId: pid, name: td?.transfer_detail_product?.name ?? "", uom: td?.transfer_detail_product?.product_uom?.name ?? "", quantity: 0 };
          }
          materialOpt[pid].quantity = parseFloat(materialOpt[pid].quantity || 0) + qty;
        });
      });

    let options = Object.values(materialOpt)
      .filter((m) => m.name)
      .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", undefined, { numeric: true, sensitivity: "base" }))
      .map((m) => ({ label: m.name, value: m.productId, ...m }));

    return { blockMaterialMap: blockMap, materialOptions: options };
  }, [transfers]);

  const { blockBadges, nonBlockTab, transferAllList } = useMemo(() => {
    const pid = selectedMaterial && selectedMaterial.value;
    let badgeMap = {};
    let aggregate = {};

    Object.values(blockMaterialMap).forEach((block) => {
      if (!badgeMap[block.blockId]) {
        badgeMap[block.blockId] = { blockId: block.blockId, name: block.name, quantity: 0 };
      }
      const blockQty = block.material[pid] || 0;
      badgeMap[block.blockId].quantity = parseFloat(blockQty) > 0 ? parseFloat(blockQty) : 0;

      if (!pid) return;
      const detail = (block.detail[pid] || []).filter((d) => d.quantity > 0);
      detail.forEach((d) => {
        const key = d.job + "|" + d.account + "|" + d.type;
        if (aggregate[key]) {
          aggregate[key].quantity = parseFloat(aggregate[key].quantity || 0) + parseFloat(d.quantity || 0);
        } else {
          aggregate[key] = { job: d.job, account: d.account, type: d.type, quantity: d.quantity };
        }
      });
    });

    (productList || []).forEach((varian) => {
      const b = varian && varian.pvar_product && varian.pvar_product.product_block;
      if (!b) return;
      if (!badgeMap[b.id]) {
        badgeMap[b.id] = { blockId: b.id, name: b.name, quantity: 0 };
      }
    });

    const nonBlock = badgeMap[null] || null;
    const badges = Object.values(badgeMap)
      .filter((b) => b.blockId !== null && b.blockId !== undefined)
      .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", undefined, { numeric: true, sensitivity: "base" }));

    const allMap = pid ? Object.values(aggregate) : [];

    return { blockBadges: badges, nonBlockTab: nonBlock, transferAllList: allMap };
  }, [blockMaterialMap, selectedMaterial, productList]);

  const purchaseChartData = useMemo(() => {
    let monthMap = {};
    (purchases || []).forEach((purchase) => {
      const m = moment.utc(purchase.transactionat).local();
      const key = m.isValid() ? m.format("YYYY-MM") : "Unknown";
      if (!monthMap[key]) {
        monthMap[key] = { label: m.isValid() ? m.format("MMM YYYY") : "Unknown", count: 0 };
      }
      (purchase.purchase_detail || []).filter(f => f.productId === selectedMaterial?.value).forEach(p => {
        monthMap[key].count += parseFloat(p.quantity);
      });

    });
    const months = Object.keys(monthMap).sort((a, b) => a.localeCompare(b));
    return {
      categories: months.map((k) => monthMap[k].label),
      data: months.map((k) => monthMap[k].count),
    };
  }, [purchases, selectedMaterial]);

  const purchaseChartOptions = useMemo(
    () => ({
      chart: {
        height: 380,
        type: "line",
        toolbar: {
          show: true,
        },
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 4,
        strokeWidth: 2,
        hover: {
          size: 6,
        },
      },
      xaxis: {
        categories: purchaseChartData.categories,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      grid: {
        show: true,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      legend: {
        show: true,
        horizontalAlign: "center",
        offsetY: -5,
      },
      tooltip: {
        enabled: true,
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          if (dataPointIndex < 0 || seriesIndex < 0) return "";
          const val = series?.[seriesIndex]?.[dataPointIndex];
          if (typeof val === "undefined" || val === null) return "";
          const cat = (w && w.globals && w.globals.categoryLabels && w.globals.categoryLabels[dataPointIndex]) ?? "";
          return (
            '<div class="px-3 py-2 rounded-3 bg-dark" style="box-shadow: 0 2px 8px rgba(0,0,0,.25);">' +
            (cat ? '<div class="text-uppercase mb-1 text-white-50" style="font-size: 11px; letter-spacing: .3px;">' + cat + "</div>" : "") +
            '<div class="fw-semibold text-white" style="font-size: 13px;">' + val + " pembelian</div>" +
            "</div>"
          );
        },
      },
    }),
    [purchaseChartData]
  );

  useEffect(() => {
    setActiveBlock("ALL");
  }, [selectedMaterial]);

  useEffect(() => {
    const containerSvgEl = document.getElementById("_0");
    unitInfoRef.current = {};

    if (containerSvgEl) {
      containerSvgEl.childNodes.forEach((el) => {
        if (el.nodeType === 1) {
          el.style.fill = "";
        }
      });
    }

    for (const varian of productList) {
      const blocks = varian?.pvar_product?.product_block;
      if (!blocks) continue;
      const resetEle = document.getElementById(blocks.name + "-" + varian.pvar_product.name);
      if (resetEle) {
        resetEle.style.fill = "";
      }
    }

    if (!selectedMaterial || !selectedMaterial.value) return;

    let colorPerBlock = {};
    for (const varian of productList) {
      const blocks = varian?.pvar_product?.product_block;
      if (!blocks) continue;
      const qty = blockMaterialMap[blocks.id] && blockMaterialMap[blocks.id].material[selectedMaterial.value];
      if (qty && qty > 0) colorPerBlock[blocks.id] = qty;
    }

    const quantities = Object.values(colorPerBlock);
    if (quantities.length === 0) return;

    const maxQty = Math.max(...quantities);
    const upper = maxQty * 0.66;
    const lower = maxQty * 0.33;

    for (const varian of productList) {
      const blocks = varian?.pvar_product?.product_block;
      if (!blocks) continue;
      const qty = blockMaterialMap[blocks.id] && blockMaterialMap[blocks.id].material[selectedMaterial.value];
      if (!qty || qty <= 0) continue;

      const key = blocks.name + "-" + varian.pvar_product.name;
      const color = qty >= upper ? "#E45742" : qty <= lower ? "#F4EB6C" : "#F7931E";
      const ele = document.getElementById(key);
      if (ele) {
        ele.style.fill = color;
      }

      unitInfoRef.current[key] = {
        key: key,
        block: blocks.name,
        unit: varian.pvar_product.name,
        material: selectedMaterial.label,
        quantity: parseFloat(qty).toFixed(2),
        uom: selectedMaterial.uom ?? "",
        color: color,
        details: (blockMaterialMap[blocks.id] && blockMaterialMap[blocks.id].detail[selectedMaterial.value]) || [],
      };
    }
  }, [selectedMaterial, svgProject, transfers, productList]);

  useEffect(() => {
    const handleMouseover = (element) => {
      if (!element.target.id) return;
      const data = unitInfoRef.current[element.target.id];
      if (!data) return;
      setInfo(data);
      const svgEl = document.getElementById(data.key);
      const mypopup = document.getElementById("dashboard-custom-tooltip");
      if (!svgEl || !mypopup) return;
      const iconPos = svgEl.getBoundingClientRect();
      mypopup.style.left = iconPos.right < 1000 ? iconPos.right + 10 + "px" : iconPos.right - 460 + 10 + "px";
      mypopup.style.top = window.scrollY + iconPos.top - 60 + "px";
      mypopup.style.display = "block";
    };
    const handleMouseout = (element) => {
      if (!element.target.id) return;
      const data = unitInfoRef.current[element.target.id];
      if (!data) return;
      const mypopup = document.getElementById("dashboard-custom-tooltip");
      if (mypopup) mypopup.style.display = "none";
    };
    document.body.addEventListener("mouseover", handleMouseover);
    document.body.addEventListener("mouseout", handleMouseout);
    return () => {
      document.body.removeEventListener("mouseover", handleMouseover);
      document.body.removeEventListener("mouseout", handleMouseout);
    };
  }, []);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial]);

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.amount.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.description.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.transaction_no.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const ParsedSVG = useMemo(() => {
    let content = svgProject && parse(svgProject);

    return <div>{content}</div>;
  }, [svgProject]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row className="mb-3 pb-1">
                  <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                      <div className="flex-grow-1">
                        <h4 className="fs-16 mb-1">
                          {date < 12 ? "Selamat Pagi" : date >= 12 && date <= 15 ? "Selamat Siang" : date < 18 ? "Selamat Sore" : "Selamat Malam"} {userData?.name}{" "}
                          {(loading || civilBudgetLoading) && (
                            <>
                              <Spinner color="primary" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                              &nbsp;
                              <Spinner color="success" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                            </>
                          )}
                        </h4>
                        <p>{userType !== "agent" ? positionMessage : ""}</p>
                      </div>
                      <div className="mt-3 mt-lg-0">
                        <form action="#">
                          <Row className="g-3 mb-0 align-items-center">
                            <div className="col-sm-auto">
                              <div className="input-group">
                                <Flatpickr
                                  className="form-control border-0 dash-filter-picker shadow"
                                  options={{
                                    mode: "range",
                                    dateFormat: "Y/m/d",
                                  }}
                                  onChange={(selectedDates, dateStr) => {
                                    let startat = "";
                                    let endat = "";
                                    let datearr = dateStr.split(" to ");
                                    if (datearr[1]) {
                                      startat = datearr[0];
                                      endat = datearr[1] ? datearr[1] : datearr[0];
                                    }
                                    //dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, startat: startat, endat: endat }));
                                  }}
                                />
                                <div className="input-group-text bg-primary border-primary text-white">
                                  <i className="ri-calendar-2-line"></i>
                                </div>
                                <UncontrolledDropdown className="card-header-dropdown ms-2 mt-2" direction="start">
                                  <DropdownToggle tag="a" className="text-reset" role="button">
                                    <span className="fw-semibold text-uppercase fs-12">Filter by: </span>
                                    <span className="text-muted">
                                      {filterBy} <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Hari Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "today" }));
                                      }}
                                    >
                                      Hari Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Kemarin");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "yesterday" }));
                                      }}
                                    >
                                      Kemarin
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("7 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "last7day" }));
                                      }}
                                    >
                                      7 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("30 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "last30day" }));
                                      }}
                                    >
                                      30 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "thismonth" }));
                                      }}
                                    >
                                      Bulan Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Lalu");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "lastmonth" }));
                                      }}
                                    >
                                      Bulan Lalu
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </div>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12}>
                    <Card className="card-height-100">
                      <CardHeader className="align-items-center d-flex justify-content-end gap-3 border-0 pb-0 flex-wrap">
                        <h4 className="flex-grow-1 py-2 mb-sm-0 fw-semibold">DISTRIBUSI MATERIAL {(loading || purchaseLoading || productVarianLoading) && (
                          <>
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </>
                        )}</h4>

                        {selectedMaterial && selectedMaterial.value && (
                          <div className="d-flex align-items-center gap-3 flex-wrap fs-12 fw-semibold">
                            <span className="d-flex align-items-center gap-1">
                              <span className="d-inline-block rounded-circle" style={{ width: "12px", height: "12px", background: "#E45742" }}></span> Terbanyak (&ge;66%)
                            </span>
                            <span className="d-flex align-items-center gap-1">
                              <span className="d-inline-block rounded-circle" style={{ width: "12px", height: "12px", background: "#F7931E" }}></span> Sedang (34-65%)
                            </span>
                            <span className="d-flex align-items-center gap-1">
                              <span className="d-inline-block rounded-circle" style={{ width: "12px", height: "12px", background: "#F4EB6C" }}></span> Terkecil (&le;33%)
                            </span>
                          </div>
                        )}
                        <div style={{ width: "260px" }}>
                          <Select
                            name="material"
                            value={selectedMaterial}
                            className="text-uppercase w-100"
                            placeholder="Pilih Material"
                            isClearable
                            onChange={(e) => {
                              setSelectedMaterial(e);
                            }}
                            options={materialOptions}
                          ></Select>
                        </div>
                        {svgProject && (
                          <div className="d-flex flex-shrink-0">
                            <button type="submit" className="btn btn-success" onClick={handlePrint}>
                              PRINT SITEPLAN &nbsp;
                              {loadingPrintSite && <Spinner size="sm" className="flex-shrink-0" role="status"></Spinner>}
                            </button>
                          </div>
                        )}
                      </CardHeader>
                      <div style={{ position: "relative" }}>
                        <div ref={printSiteRef}>
                          <CardBody className="siteplan-svg">
                            <Siteplan salesLoading={loading} justifyPillsTab={1} component={ParsedSVG} />
                          </CardBody>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* <RecentActivity /> */}
          </Row>
          <Row className="mb-4">
            <Col xl={5}>
              <Card className="h-100">
                <CardHeader className="border-0 pb-0 align-items-center d-flex">
                  <h4 className="card-title mb-0">PENGELUARAN MATERIAL {selectedMaterial && selectedMaterial.label ? ` - ${selectedMaterial.label}` : ""}</h4>
                </CardHeader>
                <CardBody>
                  {!selectedMaterial || !selectedMaterial.value ? (
                    <div className="p-4 text-center text-muted">Pilih material terlebih dahulu</div>
                  ) : (
                    <div>
                      <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                        <Badge
                          className={classnames("badge fw-normal fs-12", activeBlock === "ALL" ? "bg-info text-white fw-semibold" : "bg-soft-info text-dark")}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setActiveBlock("ALL");
                          }}
                        >
                          ALL
                        </Badge>
                        {nonBlockTab && (
                          <Badge
                            className={classnames("badge fw-normal fs-12", activeBlock === nonBlockTab.name ? "bg-info text-white fw-semibold" : "bg-soft-info text-dark")}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setActiveBlock(nonBlockTab.name);
                            }}
                          >
                            {nonBlockTab.name}
                          </Badge>
                        )}
                      </div>
                      <div className="block-badge-grid mb-3">
                        {(blockBadges || []).map((b, index) => (
                          <div key={index} className="block-badge-cell">
                            <Badge
                              className={classnames("badge fw-normal fs-12 w-100 d-flex align-items-center justify-content-center", activeBlock === b.name ? "bg-info text-white fw-semibold" : "bg-soft-info text-dark")}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setActiveBlock(b.name);
                              }}
                            >
                              {b.name}
                            </Badge>
                          </div>
                        ))}
                      </div>
                      <div className="table-responsive table-card mb-1 mt-3">
                        {activeBlock === "ALL" ? (
                          <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                            <thead>
                              <tr className="bg-white">
                                <th scope="col" className="text-start bg-light text-muted">MATERIAL</th>
                                <th scope="col" className="text-end bg-light text-muted">JUMLAH</th>
                                <th scope="col" className="text-start bg-light text-muted"></th>
                                <th scope="col" className="text-start bg-light text-muted">RAB</th>
                                <th scope="col" className="text-start fs-14 bg-light text-muted">URAIAN PEKERJAAN</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(transferAllList || []).map((el, idx) => {
                                return <tr key={idx}>
                                  <td className="text-start fw-semibold pe-2 fs-14">{selectedMaterial.label}</td>
                                  <td className="text-end fw-semibold pe-2 fs-14">{parseFloat(el.quantity || 0).toFixed(2)}</td>
                                  <td className="text-start pe-2 fs-14">{selectedMaterial.uom}</td>
                                  <td className="text-start pe-2 fs-14">{el.type}</td>
                                  <th className="text-start fs-14">{el.job}</th>
                                </tr>
                              })}
                              {transferAllList.length === 0 && (
                                <tr>
                                  <td colSpan="5" className="p-3 text-center">Belum ada data / Silahkan Pilih Material Terlebih Dahulu</td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        ) : (
                          <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                            <thead>
                              <tr className="bg-white">
                                <th scope="col" className="text-start bg-light text-muted">MATERIAL</th>
                                <th scope="col" className="text-end bg-light text-muted">JUMLAH</th>
                                <th scope="col" className="text-start bg-light text-muted"></th>
                                <th scope="col" className="text-start bg-light text-muted">RAB</th>
                                <th scope="col" className="text-start bg-light text-muted">URAIAN RAB</th>
                                <th scope="col" className="text-start fs-14 bg-light text-muted">URAIAN PEKERJAAN</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const pid = selectedMaterial.value;
                                const badge = (blockBadges || []).find((x) => x.name === activeBlock);
                                const detail = blockMaterialMap[badge ? badge.blockId : null] || {};
                                const rows = (detail.detail && detail.detail[pid]) || [];
                                if (rows.length === 0) {
                                  return (
                                    <tr>
                                      <td colSpan="6" className="p-3 text-center">Belum ada data / Silahkan Pilih Material Terlebih Dahulu</td>
                                    </tr>
                                  );
                                }
                                return rows.map((el, idx) => (
                                  <tr key={idx}>
                                    <td className="text-start fw-semibold pe-2 fs-14">{selectedMaterial.label}</td>
                                    <td className="text-end fw-semibold pe-2 fs-14">{parseFloat(el.quantity || 0).toFixed(2)}</td>
                                    <td className="text-start pe-2 fs-14">{selectedMaterial.uom}</td>
                                    <td className="text-start pe-2 fs-14">{el.type}</td>
                                    <td className="text-start pe-2 fs-14">{el.account}</td>
                                    <th className="text-start fs-14">{el.job}</th>
                                  </tr>
                                ));
                              })()}
                            </tbody>
                          </Table>
                        )}
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>

            <Col xl={7}>
              <Card>
                <CardHeader className="border-0 pb-0 align-items-center d-flex">
                  <h4 className="card-title mb-3">GRAFIK PEMBELIAN MATERIAL {selectedMaterial && selectedMaterial.label ? ` - ${selectedMaterial.label}` : ""} {purchaseChartData.data.length > 0 && currencyFormat((purchaseChartData.data).toString().split(",").reduce(function (prev, curr) {
              return parseInt(prev, 10) + parseInt(curr, 10);
            })) + ` ${selectedMaterial?.uom}`}   </h4>
                </CardHeader>
                <CardBody className="bg-primary">
                  <ReactApexChart
                    options={purchaseChartOptions}
                    series={[{ name: "Jumlah Pembelian", data: purchaseChartData.data }]}
                    type="line"
                    height="380"
                    className="apex-charts"
                  />
                </CardBody>
                <CardHeader className="border-0 pb-0 align-items-center hstack gap-3">
                  <h4 className="card-title mb-0">DISTRIBUSI MATERIAL / BLOK {block.label ? ` - ${block.label} (${block.unit} unit)` : ""}</h4>
                  <div className="">
                    <div style={{ minWidth: "80px" }}>
                      <Select
                        name="budget"
                        value={block}
                        className="text-uppercase w-100"
                        placeholder="Pilih Blok"
                        onChange={(e) => {
                          setBlock(e);
                        }}
                        options={blockList}
                      ></Select>
                    </div>
                  </div>
                  &nbsp;{" "}
                  {transferLoading && (
                    <div>
                      <Spinner color="primary" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                      <Spinner color="success" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                    </div>
                  )}
                </CardHeader>
                <CardBody>
                  <Row className="mb-2 m-0 p-0 pb-2 border-bottom">
                    <div className="hstack gap-2 col-sm-4">
                      <div className="ms-2">
                        <Label className="form-check-label fw-semibold text-uppercase">Uraian Pekerjaan</Label>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="hstack p-2 cursor-pointer form-check-label fw-semibold text-uppercase">
                        <div style={{ width: "40%" }}>Kebutuhan Material</div>
                        <div style={{ width: "20%" }}>Anggaran</div>
                        <div style={{ width: "20%" }}>Realisasi</div>
                        <div style={{ width: "20%" }}>Sisa</div>
                      </div>
                    </div>
                  </Row>
                  <SimpleBar style={{ maxHeight: "820px" }}>
                    {(civilBudgetList || [])
                      .filter((f) => f.type === "PROGRESS BANGUNAN")
                      .map((obj, i) => {
                        return (
                          <div key={i}>
                            {(obj.data || []).map((o, idx) => {
                              return (
                                <Row key={idx} className="mb-2 m-0 p-0 pb-2 border-bottom">
                                  <div className="hstack gap-2 col-sm-4">
                                    <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>
                                      &nbsp;
                                    </em>
                                    <div className="ms-2">
                                      <Label className="form-check-label fw-semibold text-uppercase">{o.cvld_account.name}</Label>
                                    </div>
                                  </div>
                                  <div className="col-sm-8">
                                    {(o.cvld_material || []).map((mat, m) => {
                                      let item = {};
                                      let arr = (transferList || []).filter((f) => f.cvlAccountId === o.civilAccountId && f.productId === mat.productId && f.blockId === block.value);
                                      arr.forEach((element) => {
                                        item.name = element.name;
                                        item.quantity = parseFloat(item?.quantity || 0) + parseFloat(element.quantity);
                                        item.uom = element?.transfer_detail_product?.product_uom?.name;
                                      });
                                      let sisa = block.unit ? parseFloat(mat.quantity * block.unit) - parseFloat(item?.quantity || 0) : parseFloat(mat.quantity).toFixed(2);
                                      return (
                                        <div
                                          key={m}
                                          className="hstack p-2 cursor-pointer"
                                          onClick={() => {
                                            expanseDataRef.current = arr;
                                            setLabel(item.name);
                                            setExpense(arr);
                                            toggleMaterial();
                                          }}
                                        >
                                          <div style={{ width: "40%" }}>{mat?.cvlm_material?.name}</div>
                                          <div style={{ width: "20%" }}>
                                            <span className="fw-semibold">{block.unit ? parseFloat(mat.quantity * block.unit).toFixed(2) : parseFloat(mat.quantity)}</span>
                                          </div>
                                          <div style={{ width: "20%" }}>
                                            <span className="fw-semibold">{parseFloat(item?.quantity || 0).toFixed(2)}</span>
                                          </div>
                                          <div style={{ width: "20%" }}>
                                            <span className={sisa < 0 ? "fw-semibold text-danger" : "fw-semibold text-success"}>
                                              {parseFloat(sisa).toFixed(2)} {item?.uom}
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </Row>
                              );
                            })}
                          </div>
                        );
                      })}
                  </SimpleBar>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal id="showModal" isOpen={modal} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggle}>
              {"PROGRESS PEMBANGUNAN"}
            </ModalHeader>
            <ModalBody>
              <CardBody className="pt-4 ps-4 pe-4">{info.description && parse(info.description)}</CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" className="btn btn-lg btn-light" onClick={toggle}>
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggleMaterial}>
              DETAIL REALISASI ANGGARAN {label}
            </ModalHeader>
            <ModalBody>
              <CardBody>
                <div>
                  <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                    <div className="col-sm-10">
                      <Row className="m-0 p-0 ">
                        <div className="fw-semibold col-sm-5 text-start">
                          <input className="search-box  w-100 form-control" placeholder="Filter Material / Transaksi" onChange={(e) => searchList(e.target.value)} />
                        </div>
                      </Row>
                    </div>
                    <div className="col-sm-2 text-end">
                      <ExportDoc data={printDetailDoc} />
                    </div>
                  </Row>
                  <SimpleBar style={{ height: "380px" }}>
                    <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                      <thead className="align-middle">
                        <tr className="table-active">
                          <td style={{ width: "20px" }}>
                            <input
                              type="checkbox"
                              className="checkboxDetailAll me-2 form-check-input"
                              checked={expense.every((item) => item.isChecked)}
                              onChange={() => {
                                const allChecked = expense.every((item) => item.isChecked);
                                const updatedData = expense.map((item) => ({
                                  ...item,
                                  isChecked: !allChecked,
                                }));
                                setExpense(updatedData);
                              }}
                            />
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Tanggal
                          </td>
                          <td>Material</td>
                          <td className="text-center" style={{ width: "170px" }}>
                            No Transaksi
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Jumlah
                          </td>
                          <td className="text-center">Keterangan</td>
                        </tr>
                      </thead>
                      <tbody id="newlink">
                        {(expense || []).map((o, i) => {
                          return (
                            <tr key={i} id={i} className="product">
                              <td className="product-id">
                                <input
                                  type="checkbox"
                                  className="checkboxDetail me-2 form-check-input"
                                  checked={o.isChecked}
                                  onChange={() => {
                                    const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                    setExpense(updatedData);
                                  }}
                                />{" "}
                                {i + 1}
                              </td>
                              <td className="text-center">{handleValidDate(o.transactionat)}</td>
                              <td className="text-start">{o.name}</td>
                              <td className="text-center">{o.transaction_no}</td>
                              <td className="text-center">{currencyFormat(parseFloat(o.amount))}</td>
                              <td className="text-center">{o.description}</td>
                            </tr>
                          );
                        })}
                        {expense.length === 0 && (
                          <tr>
                            <td colSpan="7" className="p-3 text-center">
                              Belum ada realisasi
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </SimpleBar>
                </div>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalMaterial(false);
                  }}
                >
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Card id="dashboard-custom-tooltip" className="border">
            <CardBody className={info && info.block ? "" : "d-none"}>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h5 className="fs-15 fw-bold mb-0">{info && info.block}</h5>
                <span className="ms-2 fw-semibold fs-12">{info.material}</span>
              </div>
              <div className="mb-1" style={{ clear: "both" }}>
                <em className="avatar-xs" style={{ background: info.color, width: "22px", height: "22px", display: "block", float: "left", marginRight: "5px" }}>
                  &nbsp;
                </em>{" "}
                {info.unit}
              </div>
              <hr className="my-2" />
              {(info.details || []).length === 0 && <div className="fs-12 text-muted">Tidak ada uraian</div>}
              {(info.details || []).map((d, i) => (
                <div key={i} className="d-flex justify-content-between align-items-start fs-12 border-bottom py-1">
                  <div className="pe-2">
                    <div className="fw-semibold">{d.job || "-"}</div>
                    <div className="text-muted">
                      {d.type ? d.type + " - " : ""}
                      {d.account || "-"}
                    </div>
                  </div>
                  <div className="fw-semibold text-nowrap">
                    {parseFloat(d.quantity || 0).toFixed(2)} {info.uom}
                  </div>
                </div>
              ))}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MaterialDashboard;
